// All translations: TR (default), EN, AR
export const translations = {
  tr: {
    nav: {
      home: "Ana Sayfa",
      rooms: "Odalar",
      gallery: "Galeri",
      attractions: "Safranbolu",
      contact: "İletişim",
      book: "Rezervasyon",
      admin: "Yönetim",
    },
    hero: {
      eyebrow: "Safranbolu • UNESCO Dünya Mirası",
      title: "Fatma Hanım Konağı",
      subtitle: "Tarihi konak otelinde, Safranbolu'nun kalbinde özgün bir misafirperverlik deneyimi.",
      cta_book: "Rezervasyon Yap",
      cta_call: "Bizi Arayın",
      cta_rooms: "Odalarımız",
    },
    about: {
      kicker: "Konağımız",
      title: "150 yıllık taş ve ahşap zarafet",
      body_1: "Fatma Hanım Konağı, Safranbolu'nun tarihi çarşı bölgesinde, taş duvarları ve ahşap tavanlarıyla Osmanlı sivil mimarisinin en güzel örneklerinden birini sunar.",
      body_2: "Titizlikle restore edilen konak; geleneksel Türk evi düzeniyle modern konforu, sıcak misafirperverlikle birleştirir. Tavanları 4 metre yüksekliğinde olan odalarımız sizi başka bir çağa götürür.",
      stat_years: "Yıllık Tarih",
      stat_rooms: "Özel Oda",
      stat_unesco: "UNESCO Bölgesi",
      stat_breakfast: "Yöresel Kahvaltı",
    },
    rooms: {
      kicker: "Odalarımız",
      title: "Her odanın kendine has bir hikâyesi var",
      from: "başlangıç",
      per_night: "/ gece",
      capacity: "Kapasite",
      size: "Büyüklük",
      bed: "Yatak",
      guests: "kişi",
      book_now: "Bu Odayı Rezerve Et",
    },
    booking: {
      kicker: "Rezervasyon",
      title: "Konağımızda bir gece geçirin",
      subtitle: "Formu doldurun, kısa süre içinde sizi telefonla arayalım.",
      full_name: "Ad Soyad",
      email: "E-posta",
      phone: "Telefon",
      check_in: "Giriş Tarihi",
      check_out: "Çıkış Tarihi",
      guests: "Kişi Sayısı",
      room: "Oda Tipi",
      room_any: "Önerinize bırakıyorum",
      requests: "Özel İstekler",
      requests_ph: "Erken giriş, ekstra yastık, transfer talebi...",
      submit: "Rezervasyon Talebi Gönder",
      submitting: "Gönderiliyor...",
      success_title: "Talebiniz alındı!",
      success_body: "En kısa sürede sizi telefonla arayacağız. Bizi tercih ettiğiniz için teşekkür ederiz.",
      check_availability: "Müsaitlik Kontrol Et",
      checking: "Kontrol ediliyor...",
      available: "Seçilen tarihlerde müsaitlik bulundu.",
      unavailable: "Bu tarihler için talep çakışması bulundu; yine de talep gönderebilirsiniz.",
      err_dates: "Lütfen geçerli giriş/çıkış tarihleri seçin.",
      err_required: "Lütfen tüm zorunlu alanları doldurun.",
    },
    gallery: {
      kicker: "Galeri",
      title: "Konağımızdan kareler",
      videos_title: "Video Galeri",
      videos_kicker: "Konağımızı keşfedin",
      play: "Oynat",
    },
    testimonials: {
      kicker: "Misafirlerimiz",
      title: "Konukların kaleminden",
    },
    city: {
      kicker: "Safranbolu",
      title: "Açık hava müzesi Safranbolu",
      body: "Safranbolu, UNESCO Dünya Mirası listesindeki olağanüstü Osmanlı şehir dokusu ile bilinir. Adını verdiği safran bitkisi, taş sokakları, ahşap konakları ve geleneksel zanaatları ile zamansız bir kasabadır.",
      attractions_title: "Görülmesi Gereken Yerler",
      reach_title: "Safranbolu'ya Nasıl Gidilir",
      from_istanbul: "İstanbul'dan",
      from_istanbul_body: "Otobüsle yaklaşık 6-7 saat. Özel araçla 4-5 saat (yaklaşık 400 km).",
      from_ankara: "Ankara'dan",
      from_ankara_body: "Otobüsle 2 saat 45 dk - 3 saat. Özel araçla 220 km, yaklaşık 2,5 saat.",
      by_train: "Tren ile",
      by_train_body: "En yakın istasyon Karabük'te. Karabük'ten dolmuşla 10-15 dk sürer.",
    },
    attractions: {
      cinci_han: { title: "Cinci Han", desc: "17. yüzyıldan kalma muhteşem bir kervansaray." },
      cinci_hamam: { title: "Cinci Hamamı", desc: "Hâlâ faaliyet gösteren tarihi bir Osmanlı hamamı." },
      hidirlik: { title: "Hıdırlık Tepesi", desc: "Eski şehrin panoramik manzarasını sunan tepe." },
      yoruk: { title: "Yörük Köyü", desc: "Açık hava müzesini andıran geleneksel Yörük köyü." },
      bulak: { title: "Bulak Mencilis Mağarası", desc: "Etkileyici karst mağarası — 400 m yürüyüş yolu." },
      incekaya: { title: "İncekaya Su Kemeri", desc: "Vadiyi aşan etkileyici Osmanlı su kemeri." },
    },
    contact: {
      kicker: "Bize Ulaşın",
      title: "Sizi konağımızda ağırlamak için sabırsızlanıyoruz",
      phone_label: "Rezervasyon Hattı",
      email_label: "E-posta",
      address_label: "Adres",
      map_title: "Konum",
    },
    footer: {
      tagline: "Safranbolu'nun kalbinde Osmanlı misafirperverliği.",
      links: "Bağlantılar",
      contact: "İletişim",
      rights: "Tüm hakları saklıdır.",
    },
    admin: {
      login_title: "Yönetim Paneli Girişi",
      email: "E-posta",
      password: "Şifre",
      sign_in: "Giriş Yap",
      signing: "Giriş yapılıyor...",
      logout: "Çıkış",
      bookings: "Rezervasyonlar",
      rooms: "Odalar",
      status: "Durum",
      pending: "Bekliyor",
      confirmed: "Onaylandı",
      cancelled: "İptal",
      no_bookings: "Henüz rezervasyon talebi yok.",
      guest: "Misafir",
      dates: "Tarihler",
      people: "Kişi",
      notes: "Not",
      save: "Kaydet",
      delete: "Sil",
      confirm_delete: "Silmek istediğinize emin misiniz?",
      add_room: "Yeni Oda Ekle",
      price: "Fiyat (TL)",
      capacity: "Kapasite",
      size_m2: "Büyüklük (m²)",
      active: "Aktif",
      created: "Oluşturma",
    },
    common: {
      loading: "Yükleniyor...",
      error: "Bir hata oluştu",
      try_again: "Tekrar deneyin",
      close: "Kapat",
      currency: "TL",
    },
  },

  en: {
    nav: {
      home: "Home",
      rooms: "Rooms",
      gallery: "Gallery",
      attractions: "Safranbolu",
      contact: "Contact",
      book: "Book Now",
      admin: "Admin",
    },
    hero: {
      eyebrow: "Safranbolu • UNESCO World Heritage",
      title: "Fatma Hanım Konağı",
      subtitle: "An authentic hospitality experience in a historic mansion in the heart of Safranbolu.",
      cta_book: "Book Your Stay",
      cta_call: "Call Us",
      cta_rooms: "Our Rooms",
    },
    about: {
      kicker: "Our Mansion",
      title: "150 years of stone & timber elegance",
      body_1: "Fatma Hanım Konağı stands in the historic bazaar district of Safranbolu, offering one of the finest examples of Ottoman civil architecture, with stone walls and wooden ceilings.",
      body_2: "Carefully restored, the mansion combines traditional Turkish home layout with modern comfort and warm hospitality. With 4-meter-high ceilings, our rooms transport you to another era.",
      stat_years: "Years of History",
      stat_rooms: "Unique Rooms",
      stat_unesco: "UNESCO Heritage",
      stat_breakfast: "Local Breakfast",
    },
    rooms: {
      kicker: "Our Rooms",
      title: "Each room tells its own story",
      from: "from",
      per_night: "/ night",
      capacity: "Capacity",
      size: "Size",
      bed: "Bed",
      guests: "guests",
      book_now: "Book This Room",
    },
    booking: {
      kicker: "Reservation",
      title: "Spend a night in our mansion",
      subtitle: "Fill the form and we will call you back shortly to confirm.",
      full_name: "Full Name",
      email: "Email",
      phone: "Phone",
      check_in: "Check-in",
      check_out: "Check-out",
      guests: "Guests",
      room: "Room Type",
      room_any: "Suggest the best for me",
      requests: "Special Requests",
      requests_ph: "Early check-in, extra pillow, transfer request...",
      submit: "Send Reservation Request",
      submitting: "Sending...",
      success_title: "Your request was received!",
      success_body: "We will contact you by phone shortly. Thank you for choosing us.",
      check_availability: "Check Availability",
      checking: "Checking...",
      available: "Availability confirmed for selected dates.",
      unavailable: "There is a request overlap — you may still send your request.",
      err_dates: "Please choose valid check-in / check-out dates.",
      err_required: "Please fill in all required fields.",
    },
    gallery: {
      kicker: "Gallery",
      title: "Moments from our mansion",
      videos_title: "Video Gallery",
      videos_kicker: "Explore the konak",
      play: "Play",
    },
    testimonials: {
      kicker: "Our Guests",
      title: "Words from our guests",
    },
    city: {
      kicker: "Safranbolu",
      title: "Safranbolu, an open-air museum",
      body: "Safranbolu is famed for its UNESCO World Heritage Ottoman townscape — cobbled streets, timber mansions and traditional crafts, all named after the saffron flower.",
      attractions_title: "Must-See Places",
      reach_title: "How to Reach Safranbolu",
      from_istanbul: "From Istanbul",
      from_istanbul_body: "About 6-7 hours by bus, or 4-5 hours by car (~400 km).",
      from_ankara: "From Ankara",
      from_ankara_body: "2h45 - 3h by bus, ~2.5h by car (220 km).",
      by_train: "By Train",
      by_train_body: "Nearest station is Karabük, with a 10-15 min dolmuş onward.",
    },
    attractions: {
      cinci_han: { title: "Cinci Han", desc: "A magnificent 17th-century caravanserai." },
      cinci_hamam: { title: "Cinci Hamam", desc: "A historic Ottoman bathhouse, still in operation." },
      hidirlik: { title: "Hıdırlık Hill", desc: "Panoramic viewpoint over the old town." },
      yoruk: { title: "Yörük Village", desc: "Traditional Yörük village, like an open-air museum." },
      bulak: { title: "Bulak Mencilis Cave", desc: "Striking karst cave with a 400 m walkway." },
      incekaya: { title: "İncekaya Aqueduct", desc: "Stunning Ottoman aqueduct spanning a gorge." },
    },
    contact: {
      kicker: "Get in Touch",
      title: "We can't wait to welcome you",
      phone_label: "Reservation Line",
      email_label: "Email",
      address_label: "Address",
      map_title: "Location",
    },
    footer: {
      tagline: "Ottoman hospitality at the heart of Safranbolu.",
      links: "Links",
      contact: "Contact",
      rights: "All rights reserved.",
    },
    admin: {
      login_title: "Admin Panel Login",
      email: "Email",
      password: "Password",
      sign_in: "Sign in",
      signing: "Signing in...",
      logout: "Logout",
      bookings: "Reservations",
      rooms: "Rooms",
      status: "Status",
      pending: "Pending",
      confirmed: "Confirmed",
      cancelled: "Cancelled",
      no_bookings: "No reservation requests yet.",
      guest: "Guest",
      dates: "Dates",
      people: "Guests",
      notes: "Notes",
      save: "Save",
      delete: "Delete",
      confirm_delete: "Are you sure to delete?",
      add_room: "Add New Room",
      price: "Price (TRY)",
      capacity: "Capacity",
      size_m2: "Size (m²)",
      active: "Active",
      created: "Created",
    },
    common: {
      loading: "Loading...",
      error: "Something went wrong",
      try_again: "Try again",
      close: "Close",
      currency: "TRY",
    },
  },

  ar: {
    nav: {
      home: "الرئيسية",
      rooms: "الغرف",
      gallery: "المعرض",
      attractions: "صفرانبولو",
      contact: "اتصل بنا",
      book: "احجز الآن",
      admin: "الإدارة",
    },
    hero: {
      eyebrow: "صفرانبولو • موقع تراث عالمي لليونسكو",
      title: "قصر فاطمة هانم",
      subtitle: "تجربة ضيافة أصيلة في قصر تاريخي في قلب صفرانبولو.",
      cta_book: "احجز إقامتك",
      cta_call: "اتصل بنا",
      cta_rooms: "غرفنا",
    },
    about: {
      kicker: "قصرنا",
      title: "أناقة الحجر والخشب منذ 150 عامًا",
      body_1: "يقع قصر فاطمة هانم في منطقة البازار التاريخية في صفرانبولو، ويقدم نموذجًا رائعًا للعمارة المدنية العثمانية بجدرانه الحجرية وأسقفه الخشبية.",
      body_2: "تم ترميم القصر بعناية ويجمع بين تخطيط البيت التركي التقليدي والراحة العصرية والضيافة الدافئة. بأسقف يبلغ ارتفاعها 4 أمتار، تنقلك غرفنا إلى عصر آخر.",
      stat_years: "عام من التاريخ",
      stat_rooms: "غرف مميزة",
      stat_unesco: "تراث اليونسكو",
      stat_breakfast: "إفطار محلي",
    },
    rooms: {
      kicker: "غرفنا",
      title: "لكل غرفة قصتها الخاصة",
      from: "من",
      per_night: "/ ليلة",
      capacity: "السعة",
      size: "المساحة",
      bed: "السرير",
      guests: "ضيوف",
      book_now: "احجز هذه الغرفة",
    },
    booking: {
      kicker: "الحجز",
      title: "اقضِ ليلة في قصرنا",
      subtitle: "املأ النموذج وسنتصل بك قريبًا لتأكيد الحجز.",
      full_name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      check_in: "تاريخ الوصول",
      check_out: "تاريخ المغادرة",
      guests: "عدد الضيوف",
      room: "نوع الغرفة",
      room_any: "اقترحوا الأنسب لي",
      requests: "طلبات خاصة",
      requests_ph: "وصول مبكر، وسادة إضافية، طلب نقل...",
      submit: "إرسال طلب الحجز",
      submitting: "جارٍ الإرسال...",
      success_title: "تم استلام طلبك!",
      success_body: "سنتواصل معك هاتفيًا قريبًا. شكرًا لاختياركم لنا.",
      check_availability: "تحقق من التوفر",
      checking: "جارٍ التحقق...",
      available: "متوفر في التواريخ المختارة.",
      unavailable: "يوجد تداخل في الطلبات — يمكنك إرسال طلبك على أي حال.",
      err_dates: "يرجى اختيار تواريخ وصول ومغادرة صحيحة.",
      err_required: "يرجى ملء جميع الحقول المطلوبة.",
    },
    gallery: {
      kicker: "المعرض",
      title: "لقطات من قصرنا",
      videos_title: "معرض الفيديو",
      videos_kicker: "اكتشف القصر",
      play: "تشغيل",
    },
    testimonials: {
      kicker: "ضيوفنا",
      title: "بكلمات ضيوفنا",
    },
    city: {
      kicker: "صفرانبولو",
      title: "صفرانبولو، متحف في الهواء الطلق",
      body: "تشتهر صفرانبولو بمناظرها العثمانية المدرجة في قائمة التراث العالمي لليونسكو — شوارع مرصوفة بالحصى وقصور خشبية وحرف تقليدية، وتأخذ اسمها من زهرة الزعفران.",
      attractions_title: "أماكن يجب زيارتها",
      reach_title: "كيفية الوصول إلى صفرانبولو",
      from_istanbul: "من إسطنبول",
      from_istanbul_body: "حوالي 6-7 ساعات بالحافلة، أو 4-5 ساعات بالسيارة (~400 كم).",
      from_ankara: "من أنقرة",
      from_ankara_body: "2:45 - 3 ساعات بالحافلة، حوالي 2.5 ساعة بالسيارة (220 كم).",
      by_train: "بالقطار",
      by_train_body: "أقرب محطة كارابوك، يتبعها 10-15 دقيقة بالحافلة الصغيرة.",
    },
    attractions: {
      cinci_han: { title: "جينجي خان", desc: "خان رائع يعود للقرن السابع عشر." },
      cinci_hamam: { title: "حمام جينجي", desc: "حمام عثماني تاريخي لا يزال يعمل." },
      hidirlik: { title: "تلة هيدرلك", desc: "نقطة مشاهدة بانورامية فوق البلدة القديمة." },
      yoruk: { title: "قرية يوروك", desc: "قرية يوروك تقليدية تشبه متحفًا في الهواء الطلق." },
      bulak: { title: "كهف بولاك", desc: "كهف كارستي مذهل مع ممر بطول 400 م." },
      incekaya: { title: "قناة إنجيكيا", desc: "قناة عثمانية مهيبة تعبر الوادي." },
    },
    contact: {
      kicker: "تواصلوا معنا",
      title: "نتطلع لاستقبالكم في قصرنا",
      phone_label: "خط الحجز",
      email_label: "البريد الإلكتروني",
      address_label: "العنوان",
      map_title: "الموقع",
    },
    footer: {
      tagline: "ضيافة عثمانية في قلب صفرانبولو.",
      links: "روابط",
      contact: "تواصل",
      rights: "جميع الحقوق محفوظة.",
    },
    admin: {
      login_title: "تسجيل دخول لوحة الإدارة",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      sign_in: "دخول",
      signing: "جارٍ الدخول...",
      logout: "خروج",
      bookings: "الحجوزات",
      rooms: "الغرف",
      status: "الحالة",
      pending: "قيد الانتظار",
      confirmed: "مؤكد",
      cancelled: "ملغى",
      no_bookings: "لا توجد طلبات حجز بعد.",
      guest: "ضيف",
      dates: "التواريخ",
      people: "الضيوف",
      notes: "ملاحظات",
      save: "حفظ",
      delete: "حذف",
      confirm_delete: "هل أنت متأكد من الحذف؟",
      add_room: "إضافة غرفة جديدة",
      price: "السعر (ليرة تركية)",
      capacity: "السعة",
      size_m2: "المساحة (م²)",
      active: "نشط",
      created: "تاريخ الإنشاء",
    },
    common: {
      loading: "جارٍ التحميل...",
      error: "حدث خطأ",
      try_again: "حاول مرة أخرى",
      close: "إغلاق",
      currency: "ليرة",
    },
  },
};

export const TESTIMONIALS = [
  {
    name: { tr: "Selin K.", en: "Selin K.", ar: "سيلين ك." },
    location: { tr: "İstanbul", en: "Istanbul", ar: "إسطنبول" },
    text: {
      tr: "Ahşap tavanları, taş duvarları ve sıcak misafirperverliği ile bir Osmanlı evine gerçekten konuk olduk. Sabah kahvaltısı muhteşemdi.",
      en: "The wooden ceilings, stone walls and warm hospitality made us feel like real guests in an Ottoman home. Breakfast was wonderful.",
      ar: "الأسقف الخشبية والجدران الحجرية والضيافة الدافئة جعلتنا نشعر وكأننا ضيوف حقيقيون في بيت عثماني. الإفطار كان رائعًا.",
    },
    rating: 5,
  },
  {
    name: { tr: "Mehmet A.", en: "Mehmet A.", ar: "محمد أ." },
    location: { tr: "Ankara", en: "Ankara", ar: "أنقرة" },
    text: {
      tr: "Baş Oda'nın penceresinden Safranbolu manzarası... Yıllardır hatırlayacağım bir hafta sonu oldu.",
      en: "The Safranbolu view from the Master Room window... a weekend I will remember for years.",
      ar: "إطلالة صفرانبولو من نافذة الغرفة الرئيسية... عطلة نهاية أسبوع سأتذكرها لسنوات.",
    },
    rating: 5,
  },
  {
    name: { tr: "Layla M.", en: "Layla M.", ar: "ليلى م." },
    location: { tr: "Dubai", en: "Dubai", ar: "دبي" },
    text: {
      tr: "Ailecek mükemmel bir konaklama yaşadık. Suite oda çok geniş, çocuklar için ideal.",
      en: "Wonderful family stay. The suite is very spacious, perfect for children.",
      ar: "إقامة عائلية رائعة. الجناح واسع جدًا ومثالي للأطفال.",
    },
    rating: 5,
  },
];

export const VIDEOS = [
  {
    title: { tr: "Safranbolu Yürüyüş Turu", en: "Safranbolu Walking Tour", ar: "جولة سيرًا في صفرانبولو" },
    youtube_id: "wfMBx5xAi9Y",
    thumb: "https://images.pexels.com/photos/16793889/pexels-photo-16793889.jpeg",
  },
  {
    title: { tr: "Tarihi Konak Atmosferi", en: "Historic Konak Atmosphere", ar: "أجواء القصر التاريخي" },
    youtube_id: "VkSeR-pQH3M",
    thumb: "https://images.pexels.com/photos/34154578/pexels-photo-34154578.jpeg",
  },
];

export const GALLERY_IMAGES = [
  "https://images.pexels.com/photos/36788388/pexels-photo-36788388.jpeg",
  "https://images.pexels.com/photos/32263956/pexels-photo-32263956.jpeg",
  "https://images.pexels.com/photos/14547138/pexels-photo-14547138.jpeg",
  "https://images.pexels.com/photos/30600239/pexels-photo-30600239.jpeg",
  "https://images.pexels.com/photos/30600231/pexels-photo-30600231.jpeg",
  "https://images.pexels.com/photos/37206732/pexels-photo-37206732.jpeg",
  "https://images.pexels.com/photos/28513215/pexels-photo-28513215.jpeg",
  "https://images.pexels.com/photos/16793889/pexels-photo-16793889.jpeg",
  "https://images.pexels.com/photos/34154578/pexels-photo-34154578.jpeg",
  "https://images.unsplash.com/photo-1740338680314-5da3498a61b2",
];

export const ATTRACTION_IMAGES = {
  cinci_han: "https://images.pexels.com/photos/16793889/pexels-photo-16793889.jpeg",
  cinci_hamam: "https://images.pexels.com/photos/34154578/pexels-photo-34154578.jpeg",
  hidirlik: "https://images.unsplash.com/photo-1740338680314-5da3498a61b2",
  yoruk: "https://images.pexels.com/photos/32263956/pexels-photo-32263956.jpeg",
  bulak: "https://images.pexels.com/photos/36788388/pexels-photo-36788388.jpeg",
  incekaya: "https://images.pexels.com/photos/28513215/pexels-photo-28513215.jpeg",
};
